import axios from 'axios';

const developmentURL = 'https://api.makana.cl'; //'http://localhost:8000'; // 'http://192.168.100.104:8000';
const productionURL = 'https://api.makana.cl';

export const axiosBaseInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? productionURL : developmentURL,
});
